import styled from '@emotion/styled'
import { Box, Table, TableCell, TableHead, Typography } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../util'
import { lightTheme } from '../../../../theme'

const distance = '132'

export const RootWrap = styled(Box)(`
	// border: 1px red solid;
	&.exportToPPT {padding:0;}
	&.exportToPPT > div{box-shadow:none}
	&.exportToPPT .list > div {overflow:hidden;}
	${exportToPPT_tableCss}
	
	&.exportToPPT {
		& .brandCategory {border: 0;}
		& .brandCategory > div {padding: 0;}
		& .tabWrapper {display:none;}
		
		& .list {flex-direction: column;}
        & .segmentOfSegmentOverviewRow:before { 
			position: relative;
			left: 0;
			border: 0;
			width: 100%;
			padding: 0 0 5px 0;
			margin: 10px 0 0 0;
			min-height: auto;
		}
        & .segmentOfSegmentOverviewRow { 
			border: 0;
		}
	}

    &.exportToPPTProgression {
        & .segmentOfSegmentOverviewRowProgression { background: #fff !important; box-shadow: none; padding-bottom:2px; }
        & .segmentOfSegmentOverviewRowProgression > div { padding:0; height: auto; line-height: 1; }
        & .segmentOfSegmentOverviewRowProgression .graphRow { padding-bottom:0; }
        & .segmentOfSegmentOverviewRowProgression .heading { padding-bottom:2px; }
	}

`)

export const ContentWrap = styled(Box)(`
	background: #fff;
	margin-left: ${distance}px;
	width: calc(100% - ${distance}px);
  // width : 100%;

  &.slider-init {
    margin-left : 0;
    width : 100%;
    position : relative;
  }
`)

export const HeaderWrap = styled(Box)(`
	display: flex;
	align-items: center;
	width: 100%;
`)

export const HeaderTab = styled(Box)(`
    display: flex;
	align-items: center;
	background: #F7F7F9;
	padding: 6px 10px;
	overflow: hidden;
	width: 100%;
	& .tab {
		padding: 5px 10px;
		font-size: 12px;
		font-weight: 400; // 300;
		margin-right: 2px;
		cursor: pointer;
		&.active {
			background: #fff;
			font-weight: 600; // 500;
		}
	}
`)

export const SegmentWrap = styled(Box)(`
  display : flex;
  width : 100%;

  & .segmentOfSegmentOverviewRow:before {
    content : none;
  }
`)

export const SliderWrap = styled(Box)(`
  width: 100%;
  max-width : 100vw;
  flex : 1;
  min-width : 0;
  // margin-left : ${distance}px;

  display : flex;

  & .slick-list .slick-track {
    // display : flex;
    // flex-direction : column;
  }
`)

export const SegmentRow = styled(Box)(`
	font-size: 14px;
	font-weight: 400; // 300;
	position: relative;
	// min-height: 60px;
	display:flex !important;
	flex-direction: column;
	justify-content: center;
  gap : 8px;
  width : 100%;
  margin-bottom : 8px;

	& .outerText{
		font-size: 12px;
		margin-left: 6px;
		font-weight: 400; // 300;
	}
	& ul.barRoot { background: #f1f1f1;  }

  	&:before {
		content: attr(data-age);
		position: absolute;
		left: -${distance}px;
		width: ${distance}px;
		height: calc(100% + 4px);
		display: flex;
		align-items: center;
		padding: 5px 6px;
		line-height:16px;
		top: -1px;
		left: 0;
		// position: static;
		// min-height: 38px; 
		margin: -1px 5px -1px -137px;
	}
`)

export const TitleCell = styled(Box)(`
  min-width: 120px;   
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  flex-shrink: 0;
`);

export const TitleWrap = styled(Box)(`
  width : ${distance}px;
  display : flex;
  flex-direction : column;
  justify-content: space-between;
`);

export const ListWrapper = styled(Box)(`
  display: flex;
  width: 100%;
  gap: 8px;
  flex-direction : column;

  &.slider-wrap {
    flex : 1;
    width : 600px;

    .list {
      margin-bottom : 0;
    }

    .slick-slider {
      width : 100%;
      position : initial;

      .slick-arrow {
        padding : 18px 14px!important;
        top: 40px;

        &.slick-prev {
          left: -130px;
        }
      }

      .slick-list {
        width : 100%;

        .slick-track {
          display : flex;
          gap : 12px;

        }
      }
    }
  }

`);

export const BarWrap = styled(Box)(`
	width: 100%;
  
  display : flex;
  align-items : center;
  gap : 12px;
  // flex-direction : column;

	// & .barRoot, .barItemRoot, .barSliceWrap, .barSlice {
	// 	height: 30px !important;
	// }
	& .barSlicePercentage{
		font-weight: 400; // 300;
		font-size: 14px;
	}

  &.legends {
    align-items : baseline;
    flex-direction : row;
    // margin-left: ${distance}px;
    // width: calc(100% - ${distance}px) !important;
    margin-bottom : 8px;
    margin-top : 20px;
  }

  &.slider-wrapper {
    display : block;
    // width: 100%;
    margin-left : 0;
    flex: 1;
    width: 600px;

    .slick-track {     
      display : flex;
      gap : 12px; 
      
      // .slick-slide {
      //   margin-right : 9px;
        
      //   &:last-child {
      //     margin-right : 0;
      //   }
      // }
    }
  }
`)

export const IssuesWrap = styled(Box)(`
	position: absolute;
	left: calc(100% + 5px);
	display: flex;
	align-items: center;
	& .radio {
		width: 10px;
		height: 10px;
		min-width: 10px;
		min-height: 10px;
		border: 1px solid #7E7E7E;
		margin-right: 4px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		& .box {
			width: 4.5px;
			height: 4.5px;
			min-width: 4.5px;
			min-height: 4.5px;
			background: #7E7E7E;
			border-radius: 50%;
		}
	}
	& .radio-text {
		font-size: 12px;
		font-weight: 400; // 300;
		white-space: nowrap;
	}
`)

export const LegendWrap = styled(Box)(`
	width: 100%;
	display: flex;
	justify-content: end;
	padding: 5px 5px 10px 5px;
`)

export const TabSection1 = styled(Box)(`
    display: flex;
    width: 100%;
`)

export const TabSection2 = styled(Box)(`
    display: flex;
    width: 100%;
    flex-direction:column;
`)

export const ProgressionFiltersWrapper = styled(Box)(`
    display: flex;
    width: 100%;
    margin-bottom:10px;

    & button:hover {
        background-color:transparent !important;
    }
`)

export const BrandHealthSection = styled(Box)(`
	display: flex;
	border-radius: 2px;
	background: #F7F7F9;
	box-shadow: 0px 0px 5px 0px #D9D9D9;
	flex-direction:column;
	width:100%;
	// width:calc(50% - 8px);
	margin-bottom:14px;
	// &:last-of-type { margin-bottom:0;}
`)

export const HeadingSection = styled(Box)(`
    display: flex;
    height:40px;
    line-height:40px;
    padding:0 10px;
    border-bottom:1px #fff solid;
    color: #000;
    font-size: 14px;
    font-weight: 600; // 500;
`)

export const ContentSection = styled(Box)(`
    display: flex;
    flex-direction: column;
    padding:10px;
`)

export const SubHeadingSection = styled(Typography)(`
    font-size: 12px;
    font-weight: 600; // 500;
    width:100%;
    padding: 10px 0 0 120px;
`)

export const ChartRow = styled(Box)(`
    display: flex;
    width: 100%;
    padding: 5px 5px 5px 0;
	& .barRoot {max-width: 100%;}
`)

export const RowName = styled(Box)(`
    text-transform: capitalize;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 120px;
    padding-right: 10px;
    font-weight: 400; // 300;
    font-size: 14px;
    line-height: 13px;
    text-align:right;
`)

export const RowBar = styled(Box)(
  ({ colorAndOpacity }) =>`
    width: 31%;
    height: 32px;
    display: flex !important;
    justify-content: center;
    align-items: center;
    border-radius : 4px;
    font-weight : 500;
    background-color : ${colorAndOpacity.color};
    color : ${colorAndOpacity.textColor}
`)

export const LegendText = styled(Box)(`
    width: 33.3%;
    line-height : 16px;
    font-weight : 500;
    font-size : 14px;
    text-align: left;
    padding-right: 3px;
    color : ${lightTheme.palette.secondary.main};
`)

export const TableWrapper = styled(Table)(`
  border : 1px solid #D2D5DA;
  border-radius: 4px;
  overflow: clip;   
  border-collapse : separate;


  tbody tr:last-of-type {
    td {
      border-bottom : none;
    }
  }
`)


export const StyledTableHead = styled(TableHead)(`
  // position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;

  &.MuiTableHead-root tr th {
    padding : 10px 12px;
    border-bottom : 1px solid #D2D5DA;
    font-weight : 500;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 122px;
    text-align: left;
    letter-spacing : normal;
    font-size : 14px;
  }
`)

export const BarWrapper = styled(Box)(({barWidth , bgColor}) => `
  height: 4px;
  background: #E7E7E6;
  width : 100%;
  border-radius : 0;
  position : relative;

  & .bar-filled {
    width : ${barWidth ? barWidth + '%' : '0'};
    border-radius: 50px;
    ${bgColor ? `background : ${bgColor}` : ''};
    height : 10px;
    border-radius : 0;
    position : absolute;
    top : -3px;
  }

  &.table-bar {
    height: 4px;
    background: #E7E7E6;
    border-radius: 50px;

    & .bar-filled {
      width : ${barWidth ? barWidth + '%' : '0'};
      height: 4px;
      border-radius: 50px;
      ${bgColor ? `background : ${bgColor}` : ''};
      top : 0;
    }
  }
`)

export const BarTypography = styled(Typography)(`
  width: 30px;
`)

export const BarMainWrap = styled(Box)(({barHeights, visible}) => `
  display : flex !important;
  gap: 4px;
  justify-content : space-between;
  align-items: center;
  width : 33.3%;
  ${barHeights ? `height : ${barHeights}px;` : ''}
  visibility : ${visible};

  &.bar-slider {
    width : 100%; 
  }
`)

export const TableData = styled(TableCell)(`
    border-bottom : 1px solid #D8D8D6;
    font-size : 13px;
    padding : 8px 12px;
`)

export const TdWrapper = styled(Box)( ({index , textColor}) => `
${index !== 0 ? `
      display : flex;
      gap : 10px;
      align-items : center;
      ` : ''};
    // ${textColor ? `color : ${textColor};  ` : ''}
`)

export const FilterWrapper = styled(Box)(  ({ width }) => `
  display : flex;
  justify-content : space-between;
  align-items : center;
  width: ${width ? width : '408px'};
  gap: ${width ? '0' : '8px'};
`)